// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CheckOutlineSvg from '@rsuite/icon-font/lib/action/CheckOutline';
var CheckOutline = createSvgIcon({
  as: CheckOutlineSvg,
  ariaLabel: 'check outline',
  category: 'action',
  displayName: 'CheckOutline'
});
export default CheckOutline;